import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumbs({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="text-xs md:text-sm">
      <ol className="flex flex-wrap items-center gap-2 text-foreground-500">
        {items.map((item, i) => (
          <li key={item.label} className="flex items-center gap-2">
            {item.to ? (
              <Link to={item.to} className="hover:text-primary-600 transition-colors">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-800">{item.label}</span>
            )}
            {i < items.length - 1 && <i className="ri-arrow-right-s-line text-foreground-300"></i>}
          </li>
        ))}
      </ol>
    </nav>
  );
}